<template>
  <div class="adult-check-view">
    <!-- common -->
    <div class="adult-check-page">
      <div class="wrap">
        <div class="ch-adult-wrap">
          <span class="adult-tag">
            <Over19Icon />
          </span>
          <div>
            <strong class="ch-adult-title">연령 제한 콘텐츠</strong>
            <p class="ch-adult-text01">
              <span>
                이 정보 내용은 청소년 유해물로서<br/>
                <strong>‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’</strong><br/>
                및 ‘청소년 보호법’에 따라<br/>19세 미만의 청소년이 이용할 수 없습니다
              </span>
              <br/><br/>
              <span>Wavve에서 성인인증 후 다시 시청해 주세요.</span>
            </p>
            <span class="adult-exclamation-setting">
              설정 인증 방법:<br/>
              ① Wavve 앱 또는 웹 접속<br/>
              ② 해당 콘텐츠 검색 후 선택<br/>
              ③ 성인인증 절차 진행<br/>
            </span>
          </div>
          <div class="ch-adult-btn">
            <ul>
              <li><a @click.prevent="exit()" href="#" class="round-btn-black-b">나가기</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import Over19Icon from '@/assets/svg/common/img-age-19-ll.svg'
import { get } from 'lodash'
import { UserService } from '@/common/api/api.service'
import { COOKIE_KEY_VERIFIED_ADULT, DOCUMENT_DOMAIN, URL_COOKIE_DOMAIN } from '@/common/constant'
import { mapGetters, mapMutations } from 'vuex'
import { EventBus } from '@/components/eventbus/EventBus'
import {
  displayNone,
  removeNone,
  enableBodyScroll
} from '@/common/util/ui.utils'
import { closeWindow } from '@/common/utils/apollo.interface'

export default {
  name: 'AdultForApollo',
  components: {
    Over19Icon
  },
  data () {
    return {
      dataUser: undefined,
      isShowPopup: false,
      isPooqzone: utils.cookies.isPooqZone()
    }
  },
  computed: {
    ...mapGetters(['getBeforeEnterPlayerPath'])
  },
  methods: {
    ...mapMutations(['hideAdultCheck']),
    clickVerification () {
      // removeNone('play-container')
      if (this.isPooqzone) {
        this.isShowPopup = true
        return
      }
      document.domain = DOCUMENT_DOMAIN
      let callback = encodeURIComponent(window.location.origin +
          '/callback.html?action=verifiedAdult&result=')
      let url = 'https://member.wavve.com/mobile/auth/verifyage?device=mobile&credential=' +
          utils.cookies.getCredential() + '&callback=' + callback
      let popup = window.open(url, '', '')
      popup.window.focus()
    },
    // 한번 성인 콘텐츠 확인 페이지를 보면 24시간은 같은 페이지가 안뜨게 쿠키 설정
    setCookie () {
      let expires = new Date()
      expires.setHours(expires.getHours() + 6)
      utils.cookies.setItem(COOKIE_KEY_VERIFIED_ADULT, '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
    },
    enter () {
      removeNone('.play-container')
      this.setCookie()
      if (this.$route.name === 'adultverify') {
        // referer object 있을때, 없을때
        const referer = get(this.$route, ['params', 'referer'], null)
        if (referer !== null) {
          this.$router.replace(referer)
        } else {
          this.$router.back()
        }
      } else {
        EventBus.$emit('on-enter')
      }
    },
    exit () {
      removeNone('.play-container')
      this.$nextTick(() => {
        const referer = this.getBeforeEnterPlayerPath

        if (referer.indexOf('/apollo') > -1) {
          // referer가 아폴로 페이지인 경우(아폴로페이지에서 추천, 다음회차 등으로 성인 컨텐츠 들어온 경우) 이전 페이지 이동
          this.$router.back()
        } else {
          // 그게 아닌 경우는 아폴로 웹뷰 닫기
          if (!closeWindow()) {
            // 웹뷰 닫기 실패시 걍 이전 페이지 이동
            this.$router.back()
          }
        }
      })
    }
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    enableBodyScroll()

    let interval = setInterval(() => {
      if (document.querySelector('.app-wrapper') !== null || document.querySelector('.play-container') !== null) {
        get(this.$route, 'name', '') === 'category' ? displayNone('.app-wrapper') : displayNone('.play-container')
        clearInterval(interval)
      }
    }, 50)

    var self = this

    // 유저 정보 API 호출
    UserService.userInfo().then((response) => {
      this.dataUser = response.data
    })

    // 성인 인증 후 호출되는 함수
    window.updateVerifiedInfo = () => {
      let login = utils.login.loginProc({ userType: 'credential',
        userId: utils.cookies.getCredential(),
        userPassword: '',
        saveId: '',
        autoLogin: '',
        profile: '' })
      let user = UserService.userInfo().then((response) => {
        this.dataUser = response.data
      })

      // 크리덴셜 로그인, 유저 정보 API 둘 다 성공시에 진입 페이지로 이동
      Promise.all([login, user]).then(() => {
        self.enter()
      })
    }
    utils.cookies.removeItem('enter-url', URL_COOKIE_DOMAIN, '/')
    utils.cookies.removeItem('referer-url', URL_COOKIE_DOMAIN, '/')
  },
  beforeDestroy () {
    get(this.$route, 'name', '') === 'category' ? removeNone('.app-wrapper') : removeNone('.play-container')
    this.hideAdultCheck()
  }
}
</script>
<style lang="css" src="@/assets/new-css/adult.css"></style>
